// src/global.js
export default {
    API_URL: process.env.VUE_APP_API_URL,
    website_URL: process.env.VUE_APP_WEBSITE_URL,
  };